import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { AuthFacade } from '@tvt-logistics-india/data-access';
import { Auth } from 'aws-amplify';
import { from, Observable } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionValidatorGuard implements CanActivate {
  constructor(public router: Router, public authFacade: AuthFacade) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    this.authFacade.loadAll();

    return from(Auth.currentSession()).pipe(
      takeWhile((data) => !data, true),
      map((data: any) => {
        const validUser = data?.isValid();
        const group = data?.accessToken.payload['cognito:groups'][0];

        if (validUser && group === 'Admin') {
          return true;
        } else {
          this.router.navigate(['/employee']);
          return false;
        }
      })
    );
  }
}
